const CHUNK_LOAD_ERROR_MESSAGES = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
  "Loading chunk",
  "Loading CSS chunk",
];

export const isChunkLoadError = (error: unknown): boolean => {
  if (error instanceof Error) {
    return CHUNK_LOAD_ERROR_MESSAGES.some((msg) =>
      error.message.toLowerCase().includes(msg.toLowerCase())
    );
  }

  return false;
};
